export default {
  "common.save": "Enregistrer",
  "common.cancel": "Annuler",
  "common.delete": "Supprimer",
  "common.edit": "Modifier",
  "common.add": "Ajouter",
  "common.back": "Retour",
  "common.loading": "Chargement...",
  "common.error": "Une erreur s'est produite",
  "common.success": "Succès",
  "common.confirm": "Confirmer",
  "common.search": "Rechercher",
  "common.filter": "Filtrer",
  "common.all": "Tous",
  "common.comingSoon": "Bientôt disponible",
  "common.noResults": "Aucun résultat",
  "common.retry": "Réessayer",

  "auth.login": "Connexion",
  "auth.signup": "S'inscrire",
  "auth.logout": "Déconnexion",
  "auth.email": "E-mail",
  "auth.password": "Mot de passe",
  "auth.name": "Nom complet",
  "auth.confirmPassword": "Confirmer le mot de passe",
  "auth.forgotPassword": "Mot de passe oublié ?",
  "auth.noAccount": "Pas encore de compte ?",
  "auth.haveAccount": "Vous avez déjà un compte ?",
  "auth.agreeTerms": "J'accepte les Conditions d'utilisation et la Politique de confidentialité",

  "nav.home": "Accueil",
  "nav.payments": "Paiements",
  "nav.add": "Ajouter",
  "nav.analytics": "Analyses",
  "nav.profile": "Profil",
  "nav.allPayments": "Tous les paiements",
  "nav.addPayment": "Ajouter un paiement",
  "nav.subscriptions": "Abonnements",
  "nav.calendar": "Calendrier",
  "nav.documents": "Documents",
  "nav.settings": "Paramètres",
  "nav.personalInfo": "Informations personnelles",
  "nav.changePassword": "Changer le mot de passe",
  "nav.twoFactor": "Authentification à deux facteurs",
  "nav.devices": "Appareils",
  "nav.reminders": "Rappels",
  "nav.editPayment": "Modifier le paiement",
  "nav.paymentDetail": "Détail du paiement",

  "dashboard.title": "Tableau de bord",
  "dashboard.greeting": "Bonjour",
  "dashboard.totalDue": "Total dû",
  "dashboard.thisMonth": "Ce mois-ci",
  "dashboard.upcomingPayments": "Paiements à venir",
  "dashboard.quickStats": "Statistiques rapides",
  "dashboard.noUpcoming": "Aucun paiement à venir",
  "dashboard.addFirst": "Ajoutez votre premier paiement pour commencer",
  "dashboard.budgetUsed": "Budget utilisé",

  "payments.title": "Paiements",
  "payments.add": "Ajouter un paiement",
  "payments.edit": "Modifier le paiement",
  "payments.detail": "Détail du paiement",
  "payments.amount": "Montant",
  "payments.dueDate": "Date d'échéance",
  "payments.category": "Catégorie",
  "payments.frequency": "Fréquence",
  "payments.notes": "Notes",
  "payments.status.paid": "Payé",
  "payments.status.pending": "En attente",
  "payments.status.overdue": "En retard",
  "payments.markAsPaid": "Marquer comme payé",
  "payments.deleteConfirm": "Supprimer ce paiement ?",
  "payments.frequency.once": "Une fois",
  "payments.frequency.weekly": "Hebdomadaire",
  "payments.frequency.monthly": "Mensuel",
  "payments.frequency.yearly": "Annuel",
  "payments.noPayments": "Aucun paiement",

  "subscriptions.title": "Abonnements",
  "subscriptions.add": "Ajouter un abonnement",
  "subscriptions.monthly": "Dépenses mensuelles",
  "subscriptions.active": "Actif",
  "subscriptions.paused": "Suspendu",
  "subscriptions.overdue": "En retard",
  "subscriptions.nextBilling": "Prochaine facturation",
  "subscriptions.billingCycle": "Cycle de facturation",

  "analytics.title": "Analyses",
  "analytics.spendingByCategory": "Dépenses par catégorie",
  "analytics.monthlyTrend": "Tendance mensuelle",
  "analytics.totalSpent": "Total dépensé",
  "analytics.paidThisMonth": "Payé ce mois",
  "analytics.pending": "En attente",
  "analytics.noData": "Aucune donnée pour cette période",

  "calendar.title": "Calendrier",
  "calendar.noPaymentsToday": "Aucun paiement à cette date",
  "calendar.connectGoogle": "Connecter Google Agenda",
  "calendar.export": "Exporter le calendrier (.ics)",
  "calendar.openGoogle": "Ouvrir Google Agenda",
  "calendar.sync": "Synchronisation du calendrier",

  "documents.title": "Documents",
  "documents.upload": "Télécharger un document",
  "documents.noDocuments": "Aucun document téléchargé",
  "documents.maxSize": "Max 10 Mo — PDF, JPEG, PNG",

  "profile.title": "Profil",
  "profile.settings": "Paramètres",
  "profile.reminders": "Rappels",
  "profile.personalInfo": "Informations personnelles",
  "profile.changePassword": "Changer le mot de passe",
  "profile.twoFactor": "Authentification à deux facteurs",
  "profile.devices": "Appareils",
  "profile.language": "Langue",
  "profile.currency": "Devise",
  "profile.deleteAccount": "Supprimer le compte",
  "profile.plan.free": "Plan gratuit",
  "profile.plan.pro": "Plan Pro",
  "profile.upgradeToPro": "Passer à Pro",
  "profile.connectedDevices": "Appareils connectés",
  "profile.pendingTill": "En attente jusqu'à la date",

  "reminders.title": "Préférences de rappel",
  "reminders.daysBefore": "Me rappeler avant",
  "reminders.email": "Notifications par e-mail",
  "reminders.push": "Notifications push",
  "reminders.sms": "Notifications SMS",

  "upgrade.title": "Passer à Pro",
  "upgrade.subtitle": "Débloquez toutes les fonctionnalités",
  "upgrade.perMonth": "/mois",
  "upgrade.upgrade": "Mettre à niveau",

  "notifications.title": "Notifications",
  "notifications.none": "Aucune nouvelle notification",
  "notifications.viewAll": "Voir tous les paiements",
  "notifications.overdue": "est en retard",
  "notifications.dueToday": "est dû aujourd'hui",
  "notifications.dueSoon": "est dû dans",
  "notifications.days": "jours",

  "error.required": "Ce champ est obligatoire",
  "error.invalidEmail": "Adresse e-mail invalide",
  "error.passwordTooShort": "Le mot de passe doit comporter au moins 6 caractères",
  "error.passwordMismatch": "Les mots de passe ne correspondent pas",
  "error.networkError": "Erreur réseau. Vérifiez votre connexion.",
  "error.unauthorized": "Session expirée. Reconnectez-vous.",
  "error.notFound": "Page introuvable",

  "settings.language": "Langue",
  "settings.selectLanguage": "Sélectionner la langue",
  "settings.selectCurrency": "Sélectionner la devise",
};
